module.exports = __webpack_public_path__ + "img/Networking_Build.e0ec8519.png";